export default __webpack_public_path__ + "static/media/cup@2x.c286a720.webp";